import { Space, Typography, Tooltip, Row, Button, notification } from 'antd'
import { FDCConcurrenceLevelSideEffect } from '@cims-online/shared'
import { EarlyClosureNotificationDetailsProps } from './types'

const EarlyClosureNotificationDetails: React.FC<
  EarlyClosureNotificationDetailsProps
> = ({ fieldDesignChange: { id, concurrenceLevel }, onCreate }) => {
  const tooltip = concurrenceLevel?.description
    ? `${concurrenceLevel?.name} - ${concurrenceLevel?.description}`
    : concurrenceLevel?.name
  return (
    <Space direction="vertical" size="small">
      <Typography.Paragraph>
        The <Tooltip title={tooltip}>Concurrence Level</Tooltip> associated with
        this Field Design Change triggered the{' '}
        {FDCConcurrenceLevelSideEffect.EarlyClosure.name} side effect
      </Typography.Paragraph>
      <Typography.Paragraph>
        You may link this Field Design Change to a new Design Submittal
      </Typography.Paragraph>
      <Row justify="end">
        <Space size="small">
          <Button onClick={() => notification.close(id)}>Cancel</Button>
          <Button
            type="primary"
            onClick={() => {
              onCreate()
              notification.close(id)
            }}
          >
            Create Design Submittal
          </Button>
        </Space>
      </Row>
    </Space>
  )
}

export default EarlyClosureNotificationDetails
